/* Brumalys : ajout en un clic du produit complémentaire dans le tiroir panier. */
document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-bm-upsell]');
  if (!button) return;
  event.preventDefault();
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  fetch(root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(button.dataset.bmUpsell), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' })
  })
    .then(function (response) { return response.json(); })
    .then(function (state) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && state.sections) { drawer.renderContents(state); } else { window.location.href = root + 'cart'; }
    })
    .catch(function () { window.location.href = root + 'cart'; });
});
